import { Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { SPECIAL_DATA_TEXTS } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Route } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/route.interface';

@Component({
    selector: 'app-line-details',
    templateUrl: './line-details.component.html',
    styleUrls: ['./line-details.component.scss'],
    standalone: false
})
export class LineDetailsComponent implements OnInit {
  @Output() onLineClick = new EventEmitter<Route>();
  @Output() onAgencyClick = new EventEmitter<number>();
  @Input() line: Route;
  @Input() showLineCity: boolean = false
  @Input() isPointer: boolean = false
  @Input() isAutoComplete: boolean = false
  @Input() tripHeadSign: string = ""

  destination: string
  accessibleTooltipText: string
  accessibleWithOrderTooltipText: string
  constructor(
    private readonly languageService: LanguageService,
  ){}

  ngOnInit(): void {
    if (this.line?.stops && this.line.stops.length) {
      if(this.line.agencyId === 2) {
        this.destination = this.line.routeLongName;
      } else {
        this.destination = this.tripHeadSign ? this.tripHeadSign : this.line.stops[this.line.stops.length - 1].name[this.languageService.getSelectedLanguage().symbol] || this.line.stops[this.line.stops.length - 1].name.he || ''
      }
    }
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.accessibleTooltipText = SPECIAL_DATA_TEXTS.accessibleTooltip[language.language]
      this.accessibleWithOrderTooltipText = SPECIAL_DATA_TEXTS.accessibleWithOrderTooltip[language.language]
    })
  }
}
